import request from '@/config/axios'
import { formatTime } from '@/utils'

export const getListApi = async (params: any): Promise<IResponse> => {
  const res = await request.get({ url: '/classRollCalls', params })

    const newLocal: any = (x) => {
    x.time = formatTime(x.time, 'yyyy-MM-dd HH:mm')
    return x
  }
  return {
    data: res.data ? res.data.map(newLocal) : res.map(newLocal),
    meta: res.meta
  }
}

export const getAssistantListApi = async (params: any): Promise<IResponse> => {
  const res = await request.get({ url: '/classRollCalls/assistant', params })

  return {
    data: res.data.map((x) => {
      x.time = formatTime(x.time, 'yyyy-MM-dd HH:mm')
      return x
    }),
    meta: res.meta
  }
}

export const saveApi = async (data: Partial<TableData>): Promise<IResponse> => {
  if (data.id) {
    return await request.put({ url: `/classRollCalls/${data.id}`, data })
  } else {
    return await request.post({ url: '/classRollCalls', data })
  }
}

export function getClassroomList() {
  return [
    { label: '數學大(7號大)', value: '數學大(7號大)' },
    { label: '數學小(7號小)', value: '數學小(7號小)' },
    { label: '3號大', value: '3號大' },
    { label: '3號小', value: '3號小' },
    { label: '3號吧台', value: '3號吧台' },
    { label: '197大', value: '197大' },
    { label: '197外', value: '197外' },
    { label: '197內', value: '197內' },
    { label: '193大', value: '193大' },
    { label: '193小', value: '193小' },
    { label: '191大', value: '191大' },
    { label: '191小', value: '191小' },
    { label: '6號小', value: '6號小' },
    { label: '6號大', value: '6號大' },
    { label: '8號小', value: '8號小' },
    { label: '8號中', value: '8號中' },
    { label: '8號大', value: '8號大' },
    { label: '1號大', value: '1號大' },
    { label: '1號小', value: '1號小' }
  ]
}

export const delApi = async (ids: string[] | number[]): Promise<IResponse> => {
  return await request.delete({ url: `/classRollCalls`, params: { ids } })
}

export const updateClassStatusApi = async (id: number, status: 'init' | 'change' | 'stop' | 'end' ): Promise<IResponse> => {
  return await request.put({ url: `/classRollCalls/${id}`, data: { status }})
}

export default {
  getListApi,
  saveApi,
  delApi,
  updateClassStatusApi,
  getClassroomList,
  getAssistantListApi
}
